/**
 * The parsers ChoiceSettingsPanel uses for its number fields (spec 008).
 * An invalid entry is not stored: the field keeps the text until blur, then
 * reverts to the stored value.
 */
import { CHOICE_TEXT_MAX, CHOICE_TIMER_MAX_S } from '../../../../../Shared/src/utils/choices';

/** `ok: false` = invalid, do not store; `value: undefined` = the field is empty (unset). */
export type ParsedSetting = { ok: true; value: number | undefined } | { ok: false };

const DECIMAL = /^\d+(\.\d+)?$/;

/** Timer (s): a whole number 1–120; empty = no timer. */
export function parseTimerSeconds(text: string): ParsedSetting {
  const t = text.trim();
  if (t === '') return { ok: true, value: undefined };
  if (!/^\d+$/.test(t)) return { ok: false };
  const n = Number(t);
  return n >= 1 && n <= CHOICE_TIMER_MAX_S ? { ok: true, value: n } : { ok: false };
}

/** Show (s) before end: a number ≥ 0, decimals allowed; empty = at the end (unset). */
export function parseShowBeforeEnd(text: string): ParsedSetting {
  const t = text.trim();
  if (t === '') return { ok: true, value: undefined };
  if (!DECIMAL.test(t)) return { ok: false };
  const n = Number(t);
  return Number.isFinite(n) ? { ok: true, value: n } : { ok: false };
}

/** An option label as stored: at most 120 characters (trimmed on blur by the editor). */
export function clampChoiceText(text: string): string {
  return text.slice(0, CHOICE_TEXT_MAX);
}
